import { Outlet } from "react-router-dom";
import { Layout } from "antd";
import Header from "@/console/components/Header";
import Sidebar from "@/console/components/Sidebar";
import { Suspense } from "react";

const { Content } = Layout;

export const CustomLayout = () => {
  return (
    <Layout className="h-screen flex flex-col">
      <Header />
      <Layout className="flex-grow flex flex-row overflow-hidden">
        <Sidebar />
        <Layout className="flex-grow overflow-hidden">
          <Content className="m-0 overflow-auto h-full">
            <Suspense fallback={null}>
              <Outlet />
            </Suspense>
          </Content>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default CustomLayout;
